import React, { ChangeEvent, Component, createRef, RefObject } from 'react'
import InputIcon from './InputIcon'
import InputLabel from './InputLabel'

interface InputFileProps {
  name: string
  filename: string
  accept: string
  label?: string
  placeholder?: string
  className?: string
  reference?: RefObject<HTMLInputElement>
  onChange: (
    name: string,
    file: File | null,
    filename: string,
    dataUri?: string
  ) => void
}

export default class InputFile extends Component<InputFileProps> {
  inputRef: RefObject<HTMLInputElement>

  constructor (props: any) {
    super(props)
    this.inputRef = this.props.reference || createRef()
    this.handleClick = this.handleClick.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  get placeholder () {
    const placeholder = this.props.filename || this.props.placeholder
    return <div className="text-tertiary block mt-2 truncate pr-3.5">{placeholder}</div>
  }

  get className () {
    const base = 'flex input-default cursor-pointer'
    return `${base} ${this.props.className}`
  }

  handleClick () {
    const input = this.inputRef.current
    input && input.click()
    this.setState({ file: null })
  }

  resetValue (event: ChangeEvent<HTMLInputElement>) {
    event.target.value = ''
  }

  async handleChange (event: ChangeEvent<HTMLInputElement>) {
    const { files } = event.target
    const file = files && files[0]
    const filename = file ? file.name : ''
    this.props.onChange(this.props.name, file, filename)
    if (file) {
      const reader = new FileReader()
      reader.addEventListener('load', () => {
        const dataUri = reader.result ? reader.result.toString() : undefined
        this.props.onChange(this.props.name, file, filename, dataUri)
      }, false)
      reader.readAsDataURL(file)
    } else {
      this.props.onChange(this.props.name, null, filename)
    }
    this.resetValue(event)
  }

  render () {
    return (
      <div className="block">
        <InputLabel text={this.props.label} />
        <InputIcon name="upload-2">
          <div
            className={this.className}
            onClick={this.handleClick}>
            <input
              className="w-0 h-0 leading-none"
              name={this.props.name}
              type="file"
              accept={this.props.accept}
              ref={this.inputRef}
              onChange={this.handleChange} />
            {this.placeholder}
          </div>
        </InputIcon>
      </div>
    )
  }
}
